import {

    CREATE_LOGIN_PENDING,
    CREATE_LOGIN_FULFILLED,
    CREATE_LOGIN_REJECTED,
    
    CHANGE_LOGIN

} from './loginActions'


const initialState = {
    loading: false,
    remember: false,
    login: '',
    password: '',
    token: '',
    error: null,
}

export function loginReducer(state = initialState, action) {
    switch (action.type) {
        case CHANGE_LOGIN:
            
        let value = ""
                
        if (action.payload.name.includes('login')) {
            value = action.payload.value.toLowerCase();
        } else {
            value = action.payload.value;
        }

        return Object.assign({}, state, { [action.payload.name]: value })

        case CREATE_LOGIN_PENDING:
            return Object.assign({}, state, {
                loading: true,
                token: ''
            })

        case CREATE_LOGIN_FULFILLED:
            return Object.assign({}, state, {
                loading: false,
                token: action.payload.token
            })

        case CREATE_LOGIN_REJECTED:
            return Object.assign({}, state, {
                loading: false,
                token: '',
                error: action.payload
            })

        default:
            return state
    }
}